import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "mt-4 text-left",
  "data-testid": "agenda-type-field"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block rounded bg-primary px-2 py-0.5 text-[10px] font-bold tracking-wide text-white" }, " NOVO ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-normal text-gray-500" }, [
  /*#__PURE__*/_createTextVNode(" · editar exige "),
  /*#__PURE__*/_createElementVNode("code", null, "schedule_editing")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 mt-1 text-sm text-gray-600" }, [
  /*#__PURE__*/_createTextVNode(" Define como a tela "),
  /*#__PURE__*/_createElementVNode("b", null, "Demanda"),
  /*#__PURE__*/_createTextVNode(" mede esta escala. Não altera plantões, pagamentos nem políticas. ")
], -1)
const _hoisted_5 = { class: "grid grid-cols-1 gap-6 md:grid-cols-3" }
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-gray-600",
  "data-testid": "agenda-type-lock"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("code", null, "schedule_editing", -1)
const _hoisted_10 = { "aria-hidden": "true" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Demanda", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Cobertura contínua", -1)
const _hoisted_14 = { class: "ml-5 list-disc" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "queda vs padrão", -1)
const _hoisted_16 = {
  key: 0,
  class: "text-[#9a5200]"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, "faixa mín–máx", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("permite "),
  /*#__PURE__*/_createElementVNode("b", null, "quadro-meta"),
  /*#__PURE__*/_createTextVNode(" e, com ele, "),
  /*#__PURE__*/_createElementVNode("b", null, "déficit"),
  /*#__PURE__*/_createTextVNode(" e “Criar vagas”.")
], -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "Demanda", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "Agenda variável", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("ul", { class: "ml-5 list-disc" }, [
  /*#__PURE__*/_createElementVNode("li", null, "vagas abertas, taxa de plantões apagados e faixa semanal (mín–máx);"),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("b", null, "sem"),
    /*#__PURE__*/_createTextVNode(" alerta de queda, "),
    /*#__PURE__*/_createElementVNode("b", null, "sem"),
    /*#__PURE__*/_createTextVNode(" quadro-meta e "),
    /*#__PURE__*/_createElementVNode("b", null, "sem"),
    /*#__PURE__*/_createTextVNode(" déficit.")
  ])
], -1)
const _hoisted_23 = {
  key: 0,
  class: "mt-1.5 text-[#9a5200]"
}

import { computed } from 'vue'
import SelectableCard from '@/components/designSystem/Cards/SelectableCard.vue'
import type { AgendaDetectionResponse } from '@/Network/Types/Responses/DemandResponses'
import {
  AGENDA_TYPE_LABELS,
  detectionText,
  impactModel,
  type AgendaFieldMode,
  type AgendaTypeValue
} from './agendaTypeModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'AgendaTypeField',
  props: {
    modelValue: {},
    mode: {},
    readonly: { type: Boolean },
    detection: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const options: { value: AgendaTypeValue; title: string; description: string }[] = [
  {
    value: 'AUTO',
    title: AGENDA_TYPE_LABELS.AUTO,
    description:
      'O sistema classifica pela variação semanal das horas criadas nas últimas 12 semanas e reclassifica sozinho.'
  },
  {
    value: 'CONTINUOUS',
    title: AGENDA_TYPE_LABELS.CONTINUOUS,
    description:
      'Setor com médico em todas as horas (UTI, PS, UPA, Maternidade). A Demanda compara com o padrão recente e aceita quadro-meta.'
  },
  {
    value: 'VARIABLE',
    title: AGENDA_TYPE_LABELS.VARIABLE,
    description:
      'Agenda que muda semana a semana (ambulatório, eletivas, consultórios). Sem déficit: mostra vagas abertas, plantões apagados e faixa semanal.'
  }
]

const detectionView = computed(() => detectionText(props.detection, props.mode))
const impact = computed(() => impactModel(props.modelValue, props.detection, props.mode))

const detectionClass = computed(() => {
  switch (detectionView.value.variant) {
    case 'wait':
      return 'bg-gray-100 text-gray-600'
    case 'variable':
      return 'bg-amber-50 text-amber-800'
    default:
      return 'bg-sky-50 text-sky-800'
  }
})

function select(value: AgendaTypeValue) {
  // Sem `schedule_editing` o campo é somente leitura: o clique não altera nada.
  if (props.readonly) return
  emit('update:modelValue', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", {
      class: _normalizeClass(["mt-2", _ctx.mode === 'create' ? 'font-bold text-base text-[#323232]' : 'text-gray-500 text-base'])
    }, [
      _createTextVNode(" Tipo de agenda "),
      _hoisted_3
    ], 2),
    _hoisted_4,
    _createElementVNode("div", {
      class: _normalizeClass({ 'opacity-60': _ctx.readonly })
    }, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (opt) => {
          return _createElementVNode("div", {
            key: opt.value,
            "data-testid": `agenda-type-card-${opt.value}`,
            class: _normalizeClass({ 'pointer-events-none': _ctx.readonly })
          }, [
            _createVNode(SelectableCard, {
              title: opt.title,
              description: opt.description,
              selected: _ctx.modelValue === opt.value,
              onClick: ($event: any) => (select(opt.value))
            }, {
              default: _withCtx(() => [
                (opt.value === 'AUTO')
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["mt-2 rounded px-2 py-1 text-xs", detectionClass.value]),
                      "data-testid": "agenda-type-detection"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detectionView.value.segments, (seg, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                          (seg.bold)
                            ? (_openBlock(), _createElementBlock("b", _hoisted_7, _toDisplayString(seg.text), 1))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(seg.text), 1)
                              ], 64))
                        ], 64))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["title", "description", "selected", "onClick"])
          ], 10, _hoisted_6)
        }), 64))
      ]),
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
            _createTextVNode(" 🔒 Somente leitura — alterar o tipo de agenda requer a permissão "),
            _hoisted_9,
            _createTextVNode(" nesta escala. ")
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mt-3 flex gap-2 rounded-lg border p-3 text-sm text-gray-700", 
        impact.value.type === 'VARIABLE' ? 'border-amber-200 bg-amber-50' : 'border-sky-200 bg-sky-50'
      ]),
      "data-testid": "agenda-type-impact"
    }, [
      _createElementVNode("span", _hoisted_10, _toDisplayString(impact.value.type === 'VARIABLE' ? '∿' : '≋'), 1),
      (impact.value.type === 'CONTINUOUS')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createTextVNode(" Na tela "),
            _hoisted_12,
            _createTextVNode(", as horas desta escala entram em "),
            _hoisted_13,
            _createTextVNode(": "),
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", null, [
                _createTextVNode(" alerta de "),
                _hoisted_15,
                _createTextVNode(" (≥ 5% abaixo da mediana de 12 semanas)"),
                (impact.value.overrideWarning)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(impact.value.overrideWarning), 1))
                  : _createCommentVNode("", true),
                (impact.value.moderateRange)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" — como a variação é moderada, mostra a "),
                      _hoisted_17
                    ], 64))
                  : _createCommentVNode("", true),
                _createTextVNode("; ")
              ]),
              _hoisted_18
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createTextVNode(" Na tela "),
            _hoisted_20,
            _createTextVNode(", as horas desta escala vão para a seção "),
            _hoisted_21,
            _createTextVNode(": "),
            _hoisted_22,
            (impact.value.overrideWarning)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(impact.value.overrideWarning), 1))
              : _createCommentVNode("", true)
          ]))
    ], 2)
  ]))
}
}

})